import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcSendOutlineIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, ButtonTypes, IconButton, IconViewSizes, PopupFooter } from '@gem/ui-kit';

import { CopyToClipboardText } from 'APP/components/CopyToClipboardText/CopyToClipboardText';

import { useMeetingLinkPopupPresenter } from './MeetingLinkPopup.presenter';
import styles from './MeetingLinkPopup.styles.m.css';
import { IMeetingLinkPopupProps } from './MeetingLinkPopup.types';

export const MeetingLinkPopup: FC<ICommonPopupsProps<IMeetingLinkPopupProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useMeetingLinkPopupPresenter(props);

    return (
      <Popup
        isOpened
        isShowHeader
        isHidden={props.popupInstance.isHidden}
        onClose={presenter.onClose}
        className={styles.popup}
        headerClassName={styles.popupHeader}
      >
        <div className={styles.container}>
          <div className={styles.title}>{t('new_meeting_actions_modal_header')}</div>
          <div className={styles.text}>{t('new_meeting_actions_modal_info_message')}</div>
          <div className={styles.actions}>
            <CopyToClipboardText
              text={props.params?.link || ''}
              onCopy={presenter.onCopy}
              toastMessage={t('meeting_link_is_copied')}
              className={styles.clipboard}
            />
            <IconButton
              Icon={IcSendOutlineIcon}
              onClick={presenter.onForwardLink}
              size={IconViewSizes.Medium}
              type={ButtonTypes.Button}
            />
          </div>
          <PopupFooter className={styles.popupFooter}>
            <Button
              size="20"
              onClick={presenter.onJoinCall}
              theme="primary"
            >
              {t('common_join')}
            </Button>
          </PopupFooter>
        </div>
      </Popup>
    );
  }
);
